import { useMemo } from 'react';
import { useCMSApiQuery } from '../../hooks/useCMSApiQuery';
import sha1 from 'crypto-js/sha1';
import { useBuildVars } from 'mf_core/config';

export function useAdserveContent(
  params: AdServeRequestTO,
  /**@deprecated Does not work anymore. will be removed soon*/
  cacheApi = false
) {
  const buildConfig = useBuildVars();
  const beaconId = buildConfig['ADBUTLER_BEACON_ID'];
  const beaconKey = buildConfig['ADBUTLER_BEACON_KEY'];
  const enableBeconSigning = beaconId && beaconKey;
  if (enableBeconSigning) {
    params.DeferSigning = true;
  }
  const { data, isError, isLoading, refetch } =
    useCMSApiQuery<AdServeResponseTO>('/cms/v1/adbutler/adserve', params, {
      gcTime: enableBeconSigning ? 0 : undefined,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: enableBeconSigning ? 0 : undefined,
    });

  const adServeData: AdServeResponseTO | undefined = useMemo(() => {
    if (data && beaconId && beaconKey) {
      const adServeData: AdServeResponseTO = {
        ...data,
        placements: data?.placements?.map((p) => {
          return p
            ? {
                ...p,
                accupixel_url: generateSignedURL(
                  p?.accupixel_url,
                  beaconId,
                  beaconKey
                ),
                eligible_url: generateSignedURL(
                  p?.eligible_url,
                  beaconId,
                  beaconKey
                ),
                redirect_url: generateSignedURL(
                  p?.redirect_url,
                  beaconId,
                  beaconKey,
                  '&'
                ),
                viewable_url: generateSignedURL(
                  p?.viewable_url,
                  beaconId,
                  beaconKey
                ),
              }
            : p;
        }),
      };
      return adServeData;
    } else return data;
  }, [data, beaconId, beaconKey]);
  return { data: adServeData, isError, isLoading, refetch };
}

export type AdServeRequestTO = {
  /**
   * Sample value `sitecode:en-US`
   */
  AdButlerDataKey: string[];
  DeferSigning?: boolean;
  EmailId: string;
  IsCarousel?: boolean;
  IsMultiAd: boolean;
  IsPersonalizedAd: boolean;
  ResellerId: string;
  ResourceSize?: number;
  UserName: string;
  Zone: string;
  pid?: number;
};

export type AdServeResponseTO = {
  isPageZoneDisabled?: boolean;
  placements?: AdContentTO[]; //CHECKME
  status?: string; //CHECKME
};

export type AdContentTO = {
  accompanied_html: string;
  accupixel_url: string;
  alt_text: string;
  banner_id: string;
  body: string;
  eligible_url: string;
  height: string;
  image_url: string;
  isPersonalizedAd?: boolean;
  metadata: { adobe_tracking_tag: string };
  placement_id: string;
  priority: number;
  rcb: string;
  rct: string;
  redirect_url: string;
  refresh_time: number;
  refresh_url: string;
  segment?: string;
  target: string;
  tracking_pixel: string;
  user_frequency_expiry: string;
  user_frequency_start: string;
  user_frequency_views: string;
  viewable_url: string;
  width: string;
};

function generateSignedURL(
  url: string,
  beaconSigningKeyId: string,
  beaconSigningKey: string,
  delimiter = ';'
) {
  if (beaconSigningKeyId && beaconSigningKey && url) {
    const microtime = (new Date().getTime() * 1e6).toString();
    const unsignedUrl = `${url}${delimiter}hc_id=${beaconSigningKeyId}${delimiter}mt=${microtime}`;
    const hash = sha1(unsignedUrl + beaconSigningKey).toString();
    const signedURL = `${unsignedUrl}${delimiter}hc=${hash}`;
    return signedURL;
  } else return url;
}
